import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import ActionRequired from "./ActionRequired";
import ActionRequested from "./ActionRequested";
import Delivered from "./Delivered";
import { DateRangePicker } from "react-date-range";
import RTO from "./RTO";
import axios from "axios";
import Cookies from "js-cookie";

const NdrPage = () => {


  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [orders, setOrders] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [ndrData, setNdrData] = useState([]);
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [dateFilter, setDateFilter] = useState(""); // Add this line
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [orderIds, setOrderIds] = useState("");
  const [awbNumbers, setAwbNumbers] = useState("");
  const [productName, setProductName] = useState("");
  const [channel, setChannel] = useState("");
  const [type, setType] = useState("");
  const [courier, setCourier] = useState("");
  const [attempts, setAttempts] = useState("");
  const location = useLocation()
  const { id } = useParams();


  const navigate = useNavigate();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const tabs = ["Action Required", "Action Requested", "Delivered", "RTO Initiated"];
  const isNdrRoute =
    location.pathname === "/dashboard/ndr" ||
    (location.pathname.startsWith("/dashboard/Setup&Manage/User/Profile/") &&
      location.pathname.endsWith("/ndr"));

  const tabStorageKey = isNdrRoute ? "activeNdrTab" : "activeOrderTab";

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(tabStorageKey) || "Action Required";
  });

  useEffect(() => {
    localStorage.setItem(tabStorageKey, activeTab);
  }, [activeTab, tabStorageKey]);


  const toggleFilters = () => {
    if (filtersApplied) {
      clearFilters();
      setFiltersApplied(false);
    } else {
      setShowFilters((prev) => !prev);
    }
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = Cookies.get("session");
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/orders`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data);
        setOrders(response.data.orders);
        setRefresh(false);
        setNdrData(response.data?.orders.ndrHistory || []);

        // console.log(orders)
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [refresh]);


  const clearFilters = () => {
    setDateFilter('');
    setShowCustomCalendar(false);
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
    setOrderIds('');
    setAwbNumbers('');
    setType('');
    setCourier('');
    setAttempts('');
    setChannel('');
    setFiltersApplied(false);
    setFilteredOrders(orders);
  };


  const renderTabContent = () => {
    switch (activeTab) {
      case "Action Required":
        return <ActionRequired orders={filteredOrders} />;
      case "Action Requested":
        return <ActionRequested orders={filteredOrders} />;
      case "Delivered":
        return <Delivered orders={filteredOrders} />;
      case "RTO Initiated":
        return <RTO orders={filteredOrders} />;
      default:
        return <div>Select a tab to view orders.</div>;
    }
  };

  const handleDateSuggestion = (value) => {
    let startDate, endDate;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to the start of the day

    switch (value) {
      case "today":
        startDate = new Date(today);
        endDate = new Date(today);
        break;

      case "yesterday":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 1);
        endDate = new Date(startDate);
        break;

      case "last7days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6); // 6 days before today (including today)
        endDate = new Date(today);
        break;

      case "thismonth":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today);
        break;

      case "lastmonth":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
        break;

      case "thisyear":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date(today);
        break;

      case "custom":
        setShowCustomCalendar(true); // Open the calendar for custom selection
        return; // Exit early

      default:
        return;
    }

    // Update state properly
    setSelectionRange({ startDate, endDate, key: "selection" });
    setStartDate(startDate);
    setEndDate(endDate);
    setShowCustomCalendar(false); // Close the calendar for predefined options
  };

  const applyDateFilter = (dateRange) => {
    const { startDate, endDate } = dateRange;
    setFromDate(startDate);
    setEndDate(endDate);

    // Apply filter logic based on startDate and endDate
  };

  const getToday = () => {
    const today = new Date();
    return { startDate: today, endDate: today };
  };

  const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return { startDate: yesterday, endDate: yesterday };
  };

  const getLast7Days = () => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 6); // 7 days ago
    return { startDate: sevenDaysAgo, endDate: today };
  };

  const getThisMonth = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return { startDate: firstDayOfMonth, endDate: today };
  };

  const getThisYear = () => {
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    return { startDate: firstDayOfYear, endDate: today };
  };
  const handleDateChange = (ranges) => {
    setSelectionRange(ranges.selection);
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };

  const handleSelect = (ranges) => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };



  // flex flex-col md:flex-row justify-between items-center gap-4
  return (
    <div
      className={`sm:px-2 sm:mt-2 px-1  ${showModal ? "overflow-hidden" : ""
        }`}
    >
      {!id && (
        <div className="mb-1">
          <h1 className="text-[12px] md:text-[18px] text-gray-700 font-[600]">NDR</h1>
        </div>
      )}

      <div className="flex justify-between items-center md:grid md:grid-cols-2 md:w-auto w-full">
        <div className="hidden md:flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`px-3 py-2 text-gray-700 text-[12px] md:text-[12px] rounded-lg font-[600] transition-all duration-200 ${activeTab === tab
                ? "bg-[#632C9D] text-white"
                : "bg-white text-gray-700 hover:bg-purple-200"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="relative md:hidden my-2">
        <button
          className="w-full px-3 h-[30px] bg-[#632C9D] text-white rounded-lg text-[10px] font-[600] flex justify-between items-center"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          {activeTab} <span className="ml-2">▼</span>
        </button>
        {showDropdown && (
          <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-lg shadow-lg z-[30] text-gray-700 font-[600]">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`w-full text-left px-3 py-2 text-[10px] font-[600] hover:bg-gray-200 ${activeTab === tab ? "bg-purple-100" : "hover:bg-purple-50"}`}
                onClick={() => {
                  setActiveTab(tab);
                  setShowDropdown(false);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="overflow-x-auto">{renderTabContent()}</div>
    </div>
  );
};

export default NdrPage;